import { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useDialogHooks from "../../../../../../Components/Dialog/dialog-hooks";
import { ICompanyResponse } from "../../../../../../Interfaces/responseTypes";
import { ICartItem, IDineInLocation } from "../../../../../../Interfaces/componentTypes";
import { CURRENCY_SYMBOLS } from "../../../../../../Costants/costants";
import MrByteMenu from "./Menu/menu";
import { VisitorPageContents } from "../../../visitorPage";
import MrByteProfile from "./Profile/profile";
import MainCartDialog from "../Components/Dialogs/MainCartDialog/mainCartDialog";
import Language from "../Components/Dialogs/Language/language";
import Footer from "../Components/Footer/footer";
import MyOrders from "./MyOrders/myOrders";
import TableReserveDialog from "../Components/Dialogs/TableReserveDialog/tableReserveDialog";
import { ITableReserveForm } from "../../../../../../Interfaces/formValue-interfaces";
import { getCompanyPosTerminal } from "../../../../../../Utilits/utilits";
import { useGetCompanyByIdQuery } from "../../../../../../API/authApi";

export enum ByteMenuContentTypes {
    CATEGORIES = 'categories',
    ITEMS = 'items'
};

const useByteHooks = (
    data: ICompanyResponse,
    type?: VisitorPageContents,
    dineInLocation?: IDineInLocation | null,
    dineInLocationFromUrl?: IDineInLocation | null,
) => {
    const { data: companyFromCache } = useGetCompanyByIdQuery(
        { id: data.id },
        { skip: !data?.id }
    );
    const mergedCompany = { ...data, ...(companyFromCache ?? {}), id: data.id };
    const company: ICompanyResponse = {
        ...mergedCompany,
        pos_terminal: getCompanyPosTerminal(mergedCompany) ? true : (mergedCompany.pos_terminal ?? false),
    };
    const { services } = company;
    const { i18n } = useTranslation();
    const [mainCart, setMainCart] = useState<ICartItem[] | []>([]);
    const [contentType, setContentType] = useState<VisitorPageContents>(type ?? VisitorPageContents.MENU)
    const { open, onOpen, onClose } = useDialogHooks();
    const [dialogComponent, setDialogComponent] = useState<ReactNode | null>(null);
    const [isReserveForm, setIsReserveForm] = useState<ITableReserveForm | null>(null)
    const currencySymbol = company.cost_currency ? CURRENCY_SYMBOLS[company.cost_currency] : CURRENCY_SYMBOLS.amd;
    const deliveryMinCost = company.services?.delivery.min_cost;
    const user_id = localStorage.getItem('user_id')

    const onCloseDialog = () => {
        setDialogComponent(null);
        onClose();
    };
    const onSelectLanguage = (active: string) => {
        i18n.changeLanguage(active);
        localStorage.setItem('p_m_language', active);
        onCloseDialog()
    };

    useEffect(() => {
        type && setContentType(type);

    }, [type]);

    useEffect(() => {
        const activeLanguage = localStorage.getItem(`p_m_language`);
        if (!activeLanguage) {
            setDialogComponent(
                <Language
                    logo={company.logo}
                    onSelect={onSelectLanguage}
                />
            )
            onOpen()
        }
    }, []);

    const onOpenReserveDialog = () => {
        onOpen();
        setDialogComponent(
            <TableReserveDialog
                companyId={company.id}
                company_name={company.name}
                company_logo={company.logo}
                company_contacts={company.contacts?.phone_numbers}
                cart={mainCart}
                currencySymbol={currencySymbol}
                onCloseDialog={onClose}
                setContentType={setContentType}
                start_time={company.business_profile?.start_time}
                end_time={company.business_profile?.end_time}
                business_profile={company.business_profile}
                serviceFee={Number(company.service_fee)}
                pos_terminal={company.pos_terminal}
                setDialog={setDialogComponent}
                setMainCart={setMainCart}
                setIsReserveForm={setIsReserveForm}
                isReserveForm={isReserveForm}
            />
        )
    };

    const renderPage = (type: VisitorPageContents): ReactNode => {
        switch (type) {
            case VisitorPageContents.MENU:
                return (
                    <MrByteMenu
                        data={company!}
                        mainCart={mainCart}
                        currencySymbol={currencySymbol}
                        setMainCart={setMainCart}
                        setContentType={setContentType}
                        onOpenMainCartDialog={onOpenMainCartDialog}
                        is_user={!!user_id}
                        isReserveForm={isReserveForm}
                        onOpenReserveDialog={onOpenReserveDialog}
                    />
                );
            case VisitorPageContents.PROFILE:
                return (
                    <MrByteProfile
                        data={company!}
                        setContentType={setContentType}
                        is_user={!!user_id}
                        onOpenReserveDialog={onOpenReserveDialog}
                    />
                );
            case VisitorPageContents.MY_ORDERS:
                return (
                    <MyOrders
                        company_id={company.id}
                        is_user={!!user_id}
                        logo={company.logo}
                        setContentType={setContentType}
                        services={services}
                        business_profile={company.business_profile}
                        onOpenReserveDialog={onOpenReserveDialog}
                    />
                )
            default:
                return (
                    <MrByteMenu
                        data={company!}
                        mainCart={mainCart}
                        currencySymbol={currencySymbol}
                        setMainCart={setMainCart}
                        setContentType={setContentType}
                        onOpenMainCartDialog={onOpenMainCartDialog}
                        is_user={!!user_id}
                        isReserveForm={isReserveForm}
                        onOpenReserveDialog={onOpenReserveDialog}
                    />
                )
        }
    };

    const renderFooter = () => {
        return (
            <Footer
                data={company}
                contentType={contentType}
                mainCart={mainCart}
                is_user={!!user_id}
                isReserveForm={isReserveForm}
                setContentType={setContentType}
                onOpenMainCartDialog={onOpenMainCartDialog}
                onOpenReserveDialog={onOpenReserveDialog }
            />
        )
    };


    const onOpenMainCartDialog = () => {
        onOpen();
        setDialogComponent(
            <MainCartDialog
                companyId={company.id}
                company_name={company.name}
                company_logo={company.logo}
                company_contacts={company.contacts?.phone_numbers}
                cart={mainCart}
                setMainCart={setMainCart}
                currencySymbol={currencySymbol}
                serviceFee={Number(company.service_fee)}
                pos_terminal={company.pos_terminal}
                services={company.services}
                setDialog={setDialogComponent}
                onCloseDialog={onClose}
                deliveryMinCost={deliveryMinCost}
                deliveryCities={company.services?.delivery.cities}
                setContentType={setContentType}
                start_time={company.business_profile?.start_time}
                end_time={company.business_profile?.end_time}
                business_profile={company.business_profile}
                dineInLocation={dineInLocation}
                dineInLocationFromUrl={dineInLocationFromUrl}
            />
        );
    };

    return {
        open,
        contentType,
        mainCart,
        dialogComponent,
        renderPage,
        renderFooter,
        onCloseDialog,
        setContentType,
        onOpenMainCartDialog,
    };
};

export default useByteHooks;
